
<template>
  <BaseEdit
    @edit-confirm-action="updateEntry"
    @edit-cancel-action="resetForm"
    @edit-open-action="loadServerEntry(entry.id)"
    @clear-form-errors="clearFormErrors"
    ref="baseEdit"
    width="70%"
    :formErrors="formErrors"
    :loading="loading"
    :pageLoading="pageLoading"
    :readOnly="readOnly"
    :modelNameSingular="modelNameSingular"
  >
    <template slot="editForm">
      <Form
        ref="form"
        :entry="editableEntry"
        :item="item"
        :extraData="extraData"
        :readOnly="readOnly"
        :isEdit="isEdit"
        :modelNameSingular="modelNameSingular"
      />
    </template>
  </BaseEdit>
</template>

<script>
import gql from 'graphql-tag';
import Form from './form.vue';
import BaseEdit from '@shared_components/base_edit.vue';

export default {
  data() {
    return {
      error: null,
      loading: false,
      pageLoading: false,
      editableEntry: null,
      formErrors: [],
      extraData: null
    };
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    item: {
      type: Object,
      default: null,
    },
    modelNameSingular: String,
  },
  components: {
    Form: Form,
    BaseEdit: BaseEdit
  },
  methods: {
    loadServerEntry: function(id) {
      this.editableEntry = this.entry;
      // this.editableEntry = null;
      // this.error = null;
      // this.loading = true;
      // this.$apollo
      //   .query({
      //     query: LOAD_GOAL_QUERY,
      //     fetchPolicy: "no-cache",
      //     variables: {
      //       id: id
      //     }
      //   })
      //   .then(response => {
      //     this.editableEntry = response.data.accountContext.goal;
      //     this.extraData = response.data;
      //   })
      //   .catch(response => console.log(response))
      //   .finally(() => (this.loading = false));

    },
    // updateServerEntry: function(goal) {
    //   this.pageLoading = true;
    //   var filtered = this.deepFilterEntryWithAllowedFieldsForMutation(goal, this.editableEntry.validations);
    //   // console.log(filtered, filtered);
    //   this.$apollo
    //     .mutate({
    //       mutation: UPDATE_GOAL_MUTATION,
    //       variables: {
    //         input: filtered,
    //       }
    //     })
    //     .then(response => {
    //       var errors = response.data.updateGoal.errors
    //       if (errors.length){
    //         this.formErrors = errors
    //       } else {
    //         this.$refs.baseEdit.closeDialog();
    //         this.$emit("entry-updated");
    //       }
    //     })
    //     .catch(response => console.log(response))
    //     .finally(() => (this.pageLoading = false));
    // },
    updateEntry: function() {
      if (this.$refs.form.isFormValid()){
        this.$refs.baseEdit.closeDialog();
        this.$emit("entry-updated", this.entry);
        // this.updateServerEntry(this.editableEntry);
        this.resetForm();
      }
    },
    resetForm: function() {
      this.$refs.form.resetFormInputs();
      this.formErrors = [];
    },
    clearFormErrors: function() {
      this.formErrors = [];
    }
  }
};
const LOAD_GOAL_QUERY = gql `
  query($id: ID!){
    accountContext{
      goal(id: $id) {
        id
        validations
      }
    } 
  }
`;

const UPDATE_GOAL_MUTATION = gql `
  mutation($input: GoalUpdateInputObject!) {
    updateGoal(input: $input) {
      goal {  
        id
      }
      errors
    }
  }
`;

</script>

<style scoped></style>

